import {
  spec,
  createValidateFunction,
  isValid,
  isInvalid,
  validators as originalValidators,
  toValidatorWithArgs,
} from 'egoist-js'

import * as custom from './custom-validators'
import { customMessages } from './validation-messages'

/**
 * In this file you can define functions to generate custom error messages
 * And change behaviour to support only one by one field validation (untilFail option)
 */

const [validateAll, validateAllWithOpts] = createValidateFunction({
  untilFail: false,
  messageFuncs: customMessages,
})

const validators = {
  custom,
  ...originalValidators,
}

export {
  spec,
  isValid,
  isInvalid,
  validateAll,
  validateAllWithOpts,
  validators,
  toValidatorWithArgs,
}
